import { useContext } from 'react';
import {
  Flex,
  PaginationPerPageSelect,
  Button,
  ModalContext,
  Text,
} from 'dash-ui';
import { useTranslation } from 'react-i18next';

function PropertyInventoryTableHeader() {
  const { t } = useTranslation('tables', { keyPrefix: 'inventory' });
  const { t: tLabels } = useTranslation('common', { keyPrefix: 'labels' });
  const { toggleModal } = useContext(ModalContext);

  return (
    <Flex
      w="100%"
      px={6}
      py={4}
      justifyContent="space-between"
      flexDirection="row"
      alignItems="center"
      flex={1}
    >
      <Flex flex={1} flexDirection="row">
        <Text lg semibold>
          {t`units`}
        </Text>
      </Flex>
      <Flex>
        <PaginationPerPageSelect label={`${tLabels`show`} `} w={130} ml={4} />
        <Button
          ml={4}
          icon="plus"
          px={5.5}
          onClick={() => toggleModal(true)}
        >{t`addNewButtonLabel`}</Button>
      </Flex>
    </Flex>
  );
}

export default PropertyInventoryTableHeader;
